import React, { useContext } from 'react';
import {
  Box, Checkbox as CheckboxBase, FormControlLabel, FormGroup,
} from '@mui/material';
import { FormContext, SiteContext } from '../../../contexts';
import { Link } from '../link';
import { ValidatorElement } from './validator';
import { getLegalConsentText } from './legalConsentTranslations';
import { isExternalPrivacyPolicyUrl, resolvePrivacyPolicyUrl } from '../privacyPolicyLink';

export const LegalConsentField = () => {
  const { legalConsentAccepted, setLegalConsentAccepted } = useContext(FormContext);
  const { site: { language, privacyPolicyUrl } } = useContext(SiteContext);
  const { prefix, privacyPolicy, suffix } = getLegalConsentText(language.code);
  const resolvedPrivacyPolicyUrl = resolvePrivacyPolicyUrl(privacyPolicyUrl);
  const opensInNewTab = isExternalPrivacyPolicyUrl(resolvedPrivacyPolicyUrl);

  const onValueChanged = (_, checked) => {
    setLegalConsentAccepted(checked);
  };

  return (
    <Box sx={{ color: 'var(--text-primary)', width: '100%' }}>
      <FormGroup>
        <FormControlLabel
          control={(
            <CheckboxBase
              checked={legalConsentAccepted}
              onChange={onValueChanged}
            />
          )}
          label={(
            <Box component="span" sx={{ fontSize: 'inherit' }}>
              {prefix}
              <Link
                to={resolvedPrivacyPolicyUrl}
                {...(opensInNewTab && { target: '_blank', rel: 'noopener noreferrer' })}
              >
                {privacyPolicy}
              </Link>
              {suffix}
            </Box>
          )}
        />
      </FormGroup>
      <ValidatorElement
        value={legalConsentAccepted || undefined}
        validators={['required']}
      />
    </Box>
  );
};
